// extracted by mini-css-extract-plugin
export default {"bold-children":"bold-children_JFhkoicN","table-border":"table-border_Q1qBysy5","font-family-universe":"font-family-universe_Jiat_Wmd","row-overflow":"row-overflow_vcaGE06J"};